module.exports = __webpack_public_path__ + "img/yinshua.209a5c07.jpg";